import React, { useState } from 'react';
import { Image, FlatList } from "react-native"
import type { CompetitionPayoutTypeProps, CompetitionProps, CompetitionResultTypeProps, CompetitionTypeProps, MyPlayerProps } from "../../types"
import { Icons } from '../../Components';
import { CompetitionHelpers } from '../api';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type CompetitionInfoCardProps = {
    hidden?:boolean,
    disable_collapse?:boolean,
    competition:CompetitionProps,
    competition_type:CompetitionTypeProps,
    competition_result_type:CompetitionResultTypeProps,
    competition_payouts:CompetitionPayoutTypeProps[],
    player?:MyPlayerProps,
}
const CompetitionInfoCard = ({ hidden, disable_collapse, competition, competition_type, competition_result_type, competition_payouts }:CompetitionInfoCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);
    
    const cl = competition.market_type == 'FOR_MONEY' ? '$' : 'E'

    let potential_winnings = competition.ticket_revenue
    if(competition.promo_payout){
        potential_winnings += competition.promo_payout
    }
    if(competition.guaranteed_payout){
        if(potential_winnings < parseFloat(competition.guaranteed_payout as string)){ potential_winnings = parseFloat(competition.guaranteed_payout as string) }
    }

    const renderPayouts = (data: { item:CompetitionPayoutTypeProps, index:number }) => {
        return (
            <View type='row' transparent style={{ padding:8, borderBottomWidth:1, borderColor:C.borders.light }}>
                <Text style={{ flex:1 }} theme='h2'>{CompetitionHelpers.formatPlace(data.item.tier)}{data.item.tier!= 1 ? ' Or Better': ''}</Text>
                <Text theme='h2'>Split {data.item.payout}%</Text>
            </View>
        )
    }

    if(hidden){ return <></> }

    return (
        <View float nativeID="competition_details">
            <Button 
            disabled={disable_collapse}
            style={{ flexDirection:'row', alignItems:'center', borderBottomWidth:expanded?1:0, borderColor:C.borders.light }}
            transparent
            onPress={() => setExpanded(!expanded)}>
                <Icons.SettingsIcon size={18} color={C.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme="h1">COMPETITION DETAILS</Text>
                    <Text style={{ marginTop: 4 }} theme="description">Detailed Information on this competition</Text>
                </View>
                <View transparent style={{ margin:10 }}>
                    <Text size={16} color={C.text.success} weight='bold'>{cl}{potential_winnings.toFixed(2)}</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} color={C.text.h1} size={8} />
                :<></>}
            </Button>
            {expanded ?
            <View transparent style={{ padding:20 }}>
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Ticket Price</Text>
                    <Text theme="h2">{cl}{Number(competition.buy_in).toFixed(2)}</Text>
                </View>
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Competition Type</Text>
                    <Text theme="h2">{competition_type.type.toUpperCase()}</Text>
                </View>
                {competition_type.type == 'pick' ?
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Max Pick Count</Text>
                    <Text theme="h2">{competition.max_pick_count} Picks</Text>
                </View>
                :
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Initial Balance</Text>
                    <Text theme="h2">E{competition.initial_balance}</Text>
                </View>
                }
                <View transparent type='row' style={{ padding:5 }}>
                <Text style={{flex:1}} theme="description">Current Payout</Text>
                    <Text theme="h2">{cl}{potential_winnings.toFixed(2)}</Text>
                </View>
                {competition.prize_override ?
                <View transparent style={{ padding:10, borderRadius:8, backgroundColor:C.text.gold }}>
                    <Text size={14} color={C.text.h1} weight='bold'>Additional Prize</Text>
                    <View type='row'>
                        <Image
                            source={{ uri: competition.prize_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1649737862/be_logo_jte2ux.webp' }}
                            style={{ height:50, width:50, borderRadius:4 }}
                            resizeMode='cover'
                        />
                        <Text style={{ marginLeft:10 }} size={14} weight='bold' color={C.text.h1}>{competition.prize_override}</Text>
                    </View>
                </View>
                :<></>}
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Entries</Text>
                    <Text theme="h2">{competition.tickets_sold} / {competition.available_tickets}</Text>
                </View>
                <View transparent type='row' style={{ padding:5 }}>
                    <Text style={{flex:1}} theme="description">Payout Type</Text>
                    <Text theme="h1">{competition_result_type.label.toUpperCase()}</Text>
                </View>
                <View transparent style={{ marginTop:10, padding:10, borderRadius:8, backgroundColor:C.views.illiquidMarket }}>
                    <Text style={{ padding:5 }} theme="h2">{competition_result_type.description}</Text>
                    <View transparent style={{ padding:10 }}>
                        <FlatList
                            data={competition_payouts.sort((a,b) => b.tier - a.tier)}
                            renderItem={renderPayouts}
                            keyExtractor={(item) => item.competition_payout_type_id.toString()}
                        />
                    </View>
                </View>
            </View>
            :<></>}
        </View>
    )

    
}

export default CompetitionInfoCard